import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { Attribute, Directive, ElementRef, forwardRef, Input } from '@angular/core';

@Directive({
  selector: '[appMax]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MaxDirective), multi: true }]
})
export class MaxDirective implements Validator {
  @Input() max: string;
  constructor(private elementRef: ElementRef) {}

  validate(control: AbstractControl): { [key: string]: any } {
    return Validators.max(parseInt(this.max))(control);
  }
}
